// // import React, { createContext, useState, useContext } from "react";

// // export const AuthContext = createContext();

// // export const AuthProvider = ({ children }) => {
// //   const [isAuthenticated, setIsAuthenticated] = useState(false);

// //   useEffect(() => {
// //     const token = localStorage.getItem("authToken");
// //     if (token) setIsAuthenticated(true);
// //   }, []);

// //   const login = () => {
// //     localStorage.setItem("authToken", "token");
// //     setIsAuthenticated(true);
// //   };

// //   const logout = () => {
// //     localStorage.removeItem("authToken");
// //     setIsAuthenticated(false);
// //   };

// //   return (

import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      setIsAuthenticated(true);
      setUser({ username: 'Admin' });
    }
  }, []);

  const login = (username, password) => {
    if (username === 'admin' && password === 'password') {
      localStorage.setItem('authToken', 'mock-token-123');
      setIsAuthenticated(true);
      setUser({ username: 'Admin' });
      return true;
    }
    return false;
  };

  const logout = () => {
    localStorage.removeItem('authToken');
    setIsAuthenticated(false);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout, user }}>
      {children}
    </AuthContext.Provider>
  );
};
//     <AuthContext.Provider value={{ isAuthenticated, login, logout, user }}>
